import { UserRelationEnum } from "./api-types";

export const UserRelationEnumOther: UserRelationEnum[] = [
  UserRelationEnum.Conjoint,
  UserRelationEnum.Collaborateur,
  UserRelationEnum.Enfant,
  UserRelationEnum.Autre,
]

export const UserRelationEnumPrivate: UserRelationEnum[] = [
  UserRelationEnum.Adulte,
  UserRelationEnum.Enfant,
]
